import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Dialog from "@radix-ui/react-dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

function ContentPromo() {
    const [catalogData, setCatalogData] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadCatalog = async () => {
            try {
                const res = await fetch('/data/catalog.json?t=' + Date.now());
                const data = await res.json();

                const today = new Date();
                const filtered = data.filter((item) => {
                    const start = new Date(item.start_date);
                    start.setHours(0, 0, 0, 0);
                    const end = new Date(item.end_date);
                    end.setHours(23, 59, 59, 999);
                    return today >= start && today <= end;
                });

                setCatalogData(filtered);
            } catch (err) {
                console.error('Error fetching catalog:', err);
            } finally {
                setLoading(false);
            }
        };

        loadCatalog();
    }, []);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    const handleImageClick = (img) => {
        setSelectedImage(img);
        setOpen(true);
    };

    const closePopup = () => {
        setOpen(false);
    };

    return (
        <div>
            <div className="pt-[50px] md:pt-[64px] bg-[#F1F8FF]">
                <img src="media/images/Head Banner.png" className="w-100" alt="FamilyMart Indonesia" />
            </div>
            <div className="catalog-menu px-[15px] md:px-[50px] lg:px-[70px] xl:px-[100px]">
                <div>
                    <h3 className="text-base md:text-3xl text-sky-500 text-center font-extrabold my-5">Get the best offers on your favorite snacks, drinks, and essentials! <br /> Limited-time promos — Don't miss out!</h3>
                </div>
                <hr className="border-1 md:border-2 border-solid border-cyan-600 my-5" />

                {loading ? (
                    <div className="animate-pulse">
                        <Slider {...settings}>
                            <div><img src={`${process.env.PUBLIC_URL}/media/images/sample-promo-large.png`} alt='FamilyMart Indonesia' /></div>
                            <div><img src={`${process.env.PUBLIC_URL}/media/images/sample-promo-large.png`} alt='FamilyMart Indonesia' /></div>
                            <div><img src={`${process.env.PUBLIC_URL}/media/images/sample-promo-large.png`} alt='FamilyMart Indonesia' /></div>
                        </Slider >
                    </div>
                ) : (
                    <>
                        <Slider {...settings}>
                            {catalogData.map((catalog, index) => {
                                // if (index > 1) return null;

                                return (
                                    <div key={index} > <img src={catalog.image} alt={catalog.image} onClick={() => handleImageClick(catalog.image)} /></div>
                                );
                            })}
                        </Slider >

                        {/* Modal Zoom */}
                        <Dialog.Root open={open} onOpenChange={setOpen}>
                            <Dialog.Portal>
                                <Dialog.Overlay className="fixed inset-0 bg-black/80 z-40" />
                                <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 p-4 rounded shadow-xl max-w-5xl w-full">
                                    <Dialog.Title>
                                        <VisuallyHidden>Image Preview</VisuallyHidden>
                                    </Dialog.Title>
                                    <Dialog.Description>
                                        <VisuallyHidden>Image Description</VisuallyHidden>
                                    </Dialog.Description>
                                    {/* Konten Modal */}
                                    <div className="absolute inset-0" onClick={closePopup}></div>
                                    <button
                                        onClick={closePopup}
                                        className="absolute top-4 right-4 z-20 text-white text-3xl font-bold"
                                    >
                                        &times;
                                    </button>
                                    <img
                                        src={selectedImage}
                                        alt={`Zoomed`}
                                        className="w-full object-contain max-h-screen mx-auto"
                                    />
                                </Dialog.Content>
                            </Dialog.Portal>
                        </Dialog.Root>
                    </>
                )}

                <hr className="border-1 md:border-2 border-solid border-cyan-600 my-5" />
            </div>
        </div>
    );
}

export default ContentPromo;
